// Panier Ovalour : ajout d'un produit complémentaire depuis le tiroir panier.
// Délégation sur le document, car Dawn remplace le contenu du tiroir à chaque mise à jour.
(() => {
  if (window.ovlPanierPret) return;
  window.ovlPanierPret = true;

  document.addEventListener('click', async (event) => {
    const bouton = event.target.closest('[data-ovl-extra]');
    if (!bouton || bouton.getAttribute('aria-busy') === 'true') return;

    const tiroir = document.querySelector('cart-drawer');
    const id = Number(bouton.dataset.ovlExtra);
    bouton.setAttribute('aria-busy', 'true');
    try {
      const reponse = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id, quantity: 1 }],
          sections: tiroir ? tiroir.getSectionsToRender().map((s) => s.id) : [],
          sections_url: window.location.pathname,
        }),
      });
      const donnees = await reponse.json();
      if (!reponse.ok || donnees.status) throw new Error(donnees.description || donnees.message);
      if (tiroir && donnees.sections) {
        tiroir.renderContents({ ...donnees, id });
      } else {
        window.location.href = window.routes.cart_url;
      }
    } catch (e) {
      bouton.removeAttribute('aria-busy');
      window.location.href = window.routes.cart_url;
    }
  });
})();
